<template>
  <v-layout
    column
    id="requests"
    class="overflow-y-hidden"
    style="position: relative;"
  >
    <v-flex>
      <v-toolbar
        dense
      >
        <v-toolbar-items>

          <v-btn
            flat
            @click="viewInbox"
          >Go To Inbox</v-btn>

        </v-toolbar-items>
          <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-text-field v-model="requestSearch" append-icon="search" />
        </v-toolbar-items>
      </v-toolbar>
    </v-flex>

    <v-flex id="request-messages">
      <v-layout row justify-space-between align-center class="my-4">
        <v-flex>
          <h1 class="my-2">Requests</h1>
        </v-flex>

        <v-flex justify-self-end class="text-xs-right">
          <v-pagination
            v-model="requestPage"
            :length="requestPageLength"
          />
        </v-flex>
      </v-layout>

      <h3 v-if="requestSearch" class="my-2 grey--text">Messages matching '{{ requestSearch }}'...</h3>

      <v-progress-linear indeterminate v-if="searching" />
      <v-list v-else two-line style="height: 70vh; overflow-y: scroll;">
        <template v-for="(message, i) in messageList">

          <v-layout
            v-if="viewedMessage && message.id == viewedMessage.id"
            class="py-2 grey lighten-5"
            column
          >
            <v-flex>
              <v-toolbar dense class="white" :class="[`${ viewedMessage.systemMessage ? 'blue lighten-5' : '' }`]">
                <v-toolbar-side-icon
                  @click="collapseMessage"
                >
                  <v-icon>unfold_less</v-icon>
                </v-toolbar-side-icon>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-flex>

            <v-flex class="pa-4 white" :class="{ 'flagged-border': message.flagged }" >
              <h2>{{ viewedMessage.subject }}</h2>
              <h3 class="message-details font-weight-regular mb-2"><span class="subtle font-weight-regular">From</span> {{ viewedMessage.sender.displayName }} <span class="subtle font-weight-regular">at {{ viewedMessage.sentAt | moment('h:mma on dddd, MMMM Do') }}</span></h3>
              <div style="white-space: pre-wrap" v-html="viewedMessage.message"></div>
            </v-flex>
          </v-layout>

          <v-list-tile
            v-else
            :class="messageClasses(message)"
            @click="viewMessage(message)"
            class="message-in-list px-1"
          >
            <v-icon class="hover-expand">
              unfold_more
            </v-icon>
            <v-list-tile-content>
              <v-list-tile-title>
                <v-layout row justify-space-between>
                  <v-flex grow :class="`${ !message.read ? 'font-weight-bold' : '' }`">
                    <!-- TODO?
                    <div class="d-inline-block" v-if="message.messagesInThread > 2">
                      ({{ message.messagesInThread }})
                    </div>
                    -->
                    {{ truncate(message.subject, 80) }}
                  </v-flex>
                  <v-flex shrink>
                    <div v-if="$moment(message.sentAt).isBefore($moment().startOf('day'))">
                      {{ message.sentAt | moment('dddd, MMMM Do') }}
                    </div>
                    <div v-else>
                      {{ message.sentAt | moment('h:mm a') }}
                    </div>
                  </v-flex>
                </v-layout>
              </v-list-tile-title>

              <v-list-tile-sub-title>
                <span class="black--text">{{ message.sender.displayName }}</span> - {{ message.message }}
              </v-list-tile-sub-title>
            </v-list-tile-content>

          </v-list-tile>
          <v-divider></v-divider>
        </template>
      </v-list>
    </v-flex>
  </v-layout>

</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('userAuth', [
      'user'
    ]),
    ...mapState('messages', [
      'requestMessages',
    ]),
    ...mapGetters('messages', [
      'recentFirstRequests',
    ]),
    requestPageLength: function() {
      return Math.ceil(this.requestQueryTotal / this.limit);
    },
    recipients () {
    },
    messageList () {
      return this.recentFirstRequests
    },
    composeFieldsPresent () {
      if (this.replyingToMessage) {
        if (this.newMessageBody) {
          return true
        }
      }
      if (
        this.newMessageTo &&
        this.newMessageBody
      ) {
        return true
      }
      return false
    },
    filteredRequestMessages () {
      if (!this.requestSearch) {
        return this.recentFirstRequests
      } else {
        const search = this.requestSearch.toLowerCase()
        return this.recentFirstRequests.filter(function(message){
          const subject = message.subject ? message.subject : ''
          return subject.toLowerCase().indexOf(search) > -1 ||
                 message.message.toLowerCase().indexOf(search) > -1 ||
                 message.sender.displayName.toLowerCase().indexOf(search) > -1
        })
      }
    },
  },
  watch: {
      requestSearch: function(search) {
        if (!search) {
          this.requestPage = 1;
          this.doSearchRequest();
        }
        this.requestPage = 1;
        this.searchRequestDebounced();
      },

      requestPage: function(val) {
        this.doSearchRequest();
      },
  },
  data () {
    return {
      requestPage: 1,
      requestQueryTotal: 1,
      searching: false,
      limit: 40,
      requestSearch: '',
      viewedMessage: null,
    }
  },
  methods: {
      doSearchRequest() {
        this.$store
          .dispatch('messages/searchRequests', {
            page: this.requestPage,
            limit: this.limit,
            searchTerm: this.requestSearch,
          })
          .then(res => {
            this.searching = false;
            this.requestQueryTotal = res.queryTotal;
          });
      },

      searchRequestDebounced() {
        this.requestSearch = this.requestSearch.toLowerCase();

        this.searching = true;
        // debounce
        // cancel pending call
        clearTimeout(this._requestSearchTimer);

        // delay new call 500ms
        this._requestSearchTimer = setTimeout(() => {
          this.doSearchRequest();
        }, 500);
      },
    messageClasses (message) {
      return {
        'blue lighten-4': message.systemMessage && !message.read,
        'blue lighten-5': message.systemMessage && message.read,
        'grey lighten-4': !message.systemMessage && message.read,
        'flagged-border': message.flagged,
      }
    },
    fetchData () {
      this.$store.dispatch('messages/getRequests', {page: 1, limit: this.limit})
      .then(res => {
        this.requestQueryTotal = res.queryTotal;
        if (this.$route.query.messageId) {
          const messageId = this.$route.query.messageId
          const message = this.requestMessages.find(m => m.id == messageId)
          if (message) {
            this.setViewedMessage(message)
          } else {
            this.$router.push({ query: {} })
          }
        }
      })
    },

    viewInbox () {
      this.$router.replace({ name: 'messages' })
    },

    viewMessage (message) {
      this.$router.push({ query: { messageId: message.id } })
      this.markRead(message)
      this.setViewedMessage(message)
    },
    setViewedMessage (message) {
      this.viewedMessage = message
    },
    collapseMessage () {
      this.$router.push({ name: 'requests' })
      this.viewedMessage = null
    },
    markRead (message) {
      if (!message.read) {
        this.$store.dispatch('messages/markRead', message.id)
        .finally(r => {
          this.$store.dispatch('messages/getUnreadCount')
        })
      }
    },
    markUnread (message) {
      if (message.read) {
        this.$store.dispatch('messages/markUnread', message.id)
        .finally(r => {
          this.$store.dispatch('messages/getUnreadCount')
        })
      }
      this.collapseMessage()
    },
    truncate (message, chars) {
      if ( message && message.length > chars ) {
        return `${ message.substring(0, chars - 2) }...`
      } else if ( !message ) {
        return "<No Subject>"
      } else {
        return message
      }
    }
  }
}
</script>

<style scoped>
.hover-expand {
  display: none;
  position: absolute;
  left: -6px;
}
.request-tools {
  opacity: 1;
  display: none;
  position: absolute;
  right: 185px;
  bottom: 0px;
}
.message-in-list:hover .hover-expand {
  display: block;
}
.message-in-list:hover .request-tools {
  display: block;
}
.message-in-list.flagged-border {
  border-left: 2px solid orange !important;
}

.flagged-border {
  border-left: 2px solid orange !important;
}
</style>

<style>
</style>
